import React, { useEffect, useState } from 'react';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText,
  Button,
  HeaderText,
  Stack,
} from '../../ui';
import { NotificationsAlertCircleIcon } from '../../ui/Icons';
import type { VerificationIssueBanner } from './StripeVerificationBanners';

export type StripeVerificationBannerProps = {
  providerId: number,
  verificationIssueBanner: VerificationIssueBanner;
};

const StripeVerificationBanner: React.FC<StripeVerificationBannerProps> = ({
  providerId,
  verificationIssueBanner,
}) => {
  const [actionParams, setActionParams] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    setActionParams(!verificationIssueBanner.action
      ? null
      : {
        ...verificationIssueBanner.action.params,
        providerId,
      });
  }, [providerId, verificationIssueBanner]);

  return (
    <Inline
      testID="stripe-verification-banner"
      padding={16}
      borderRadius={3}
      borderWidth={1}
      alignItems="flex-start"
      borderColor={colors.petal}
      borderStyle="solid"
      minWidth="100%"
      maxWidth="100%"
      color={colors.redLite}
    >
      <Box
        flexBasis={18}
        testID="stripe-verification-banner-icon"
      >
        <NotificationsAlertCircleIcon
          width={18}
          height={18}
          backgroundColor={colors.red}
          color={colors.whiteWash}
          borderColor={colors.red}
        />
      </Box>
      <Stack
        paddingLeft={12}
        alignItems="flex-start"
        flexShrink={1}
      >
        <HeaderText
          level={3}
          testID="stripe-verification-banner-header"
        >
          {verificationIssueBanner.header}
        </HeaderText>
        <BodyText
          appearance="medium"
          testID="stripe-verification-banner-body"
        >
          {verificationIssueBanner.body}
        </BodyText>
        {verificationIssueBanner.action && (
          <Box paddingTop={8}>
            <Button
              text={verificationIssueBanner.ctaText}
              link={verificationIssueBanner.action.route}
              linkParams={actionParams}
              clickTracking="verification_error_banner_cta_clicked"
              clickParam={{
                providerId,
                ctaText: verificationIssueBanner.ctaText,
                verificationError: verificationIssueBanner.key,
              }}
              appearance="outline"
              size="small"
              testID="stripe-verification-banner-cta"
              style={{
                background: 'transparent',
                padding: '2px 6px',
                lineHeight: '12px',
              }}
            />
          </Box>
        )}
      </Stack>
    </Inline>
  );
};

export default StripeVerificationBanner;
